import { makeAutoObservable } from "mobx";
import { enableStaticRendering } from "mobx-react";

const isServer = typeof window === "undefined";
enableStaticRendering(isServer);

class VenuePageStore {
  page = { venue: null };

  constructor(initialData) {
    makeAutoObservable(this);

    if (initialData) {
      this.page.venue = initialData.venue;
    }
  }

  setVenue = (venue) => {
    this.page.venue = venue;
  };

  get venueName() {
    return this.page.venue?.formattedName;
  }

  get venueId() {
    return this.page.venue?.id;
  }

  get venueProfile() {
    return this.page.venue?.profile;
  }
}

export default VenuePageStore;
